import React from "react"

export default function DiscordIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.827 25.42a213.26 213.26 0 001.81 2.194c5.74-.182 8.11-3.735 8.344-4.085A.183.183 0 0132 23.5c0-8.747-3.949-15.849-3.949-15.849-3.92-2.934-7.677-2.852-7.677-2.852l-.384.439c4.661 1.398 6.828 3.455 6.828 3.455a22.795 22.795 0 00-8.254-2.605 23.201 23.201 0 00-5.54.055 2.702 2.702 0 00-.465.055c-2.15.259-4.249.84-6.225 1.727a21.758 21.758 0 00-1.618.768s2.249-2.166 7.185-3.565l-.275-.329S7.897 4.718 3.95 7.652c0 0-3.949 7.102-3.949 15.85 0 0 2.303 3.948 8.363 4.14 0 0 1.015-1.207 1.838-2.249-3.483-1.042-4.8-3.208-4.8-3.208s.275.192.769.466c.027 0 .027 0 .11.055.04.027.082.048.123.069.04.02.082.04.123.068.645.356 1.314.668 2.002.932 1.3.528 2.65.923 4.03 1.18 2.346.45 4.754.46 7.103.027a19.664 19.664 0 003.976-1.18 15.693 15.693 0 003.153-1.617s-1.371 2.221-4.963 3.236zm-3.73-7.484c0-1.673 1.235-3.016 2.798-3.016 1.535 0 2.797 1.343 2.797 3.016s-1.262 3.016-2.797 3.016c-1.536 0-2.797-1.343-2.797-3.016zm-10.008 0c0-1.673 1.234-3.016 2.797-3.016 1.563 0 2.797 1.343 2.797 3.016s-1.261 3.016-2.797 3.016c-1.536 0-2.797-1.343-2.797-3.016z"
        fill="currentColor"
      />
    </svg>
  )
}
